//@ts-ignore
import {
  CONNECT_BTN_CLICKED,
  SET_COMP_ID,
  DISCONNECT_BTN_CLICKED,
  CONNECT_ERROR,
  SET_IS_ALL_CALENDARS_UNCHECKED,
  ON_SETTINGS_LOAD,
  ADD_EVENT_COLOR,
  HANDLE_MONTH_CHANGE,
  HANDLE_TIMEZONE_CHANGE,
  UPDATE_ISDEMOSSR,
  IS_DATES_RETURN,
  REFRESH_DATA,
  GET_RECURRENCE_BY_RECURRENCEID,
  HANDLE_CONNECT_CLICKED,
  UPDATE_EVENTS_FOR_CALENDAR_SELECTED,
  UPDATE_CALENDAR_SELECTED,
  UPDATE_MONTH_EXISTS,
  IS_LOADED,
  IS_SETTINGS_LOADER,
  ON_WIDGET_LOAD,
  UPDATE_CALENDAR_LIST,
} from '../actions/actionType';

import { calendarsListFromObj } from './utils';

export default (state = {}, action: any) => {
  switch (action.type) {
    case ON_WIDGET_LOAD:
      return {
        ...state,
        calendarsList: calendarsListFromObj(action.payload.calendarsList),
        dates: action.payload.dates,
        isDatesReturn: true,
        isPreLoaded: false,
        isDemoContent: action.payload.isDemoContent,
      };
    case IS_DATES_RETURN:
      return {
        ...state,
        isDatesReturn: action.payload.isDatesReturn,
      };
    case IS_LOADED:
      return {
        ...state,
        isLoaded: action.payload.isLoaded,
      };
    case IS_SETTINGS_LOADER:
      return {
        ...state,
        isSettingsLoader: action.payload.isSettingsLoader,
      };
    case GET_RECURRENCE_BY_RECURRENCEID:
      return {
        ...state,
        recurrences: action.payload.recurrences,
        dates: action.payload.dates,
      };
    case UPDATE_EVENTS_FOR_CALENDAR_SELECTED:
      return {
        ...state,
        dates: action.payload.dates,
        calendarsExistArr: action.payload.calendarsExistArr,
      };
    case UPDATE_CALENDAR_SELECTED:
      return {
        ...state,
        calendarsExistArr: action.payload.calendarsExistArr,
      };
    case HANDLE_MONTH_CHANGE:
      return {
        ...state,
        dates: action.payload.dates,
        monthExistsArr: action.payload.monthExistsArr,
        monthEventsExistsArr: action.payload.monthEventsExistsArr,
        //HANDLE_MONTH_CHANGE
      };
    case UPDATE_MONTH_EXISTS:
      return {
        ...state,
        monthExistsArr: action.payload.monthExistsArr,
        monthEventsExistsArr: action.payload.monthEventsExistsArr,
      };

    case HANDLE_TIMEZONE_CHANGE:
      return {
        ...state,
        dates: action.payload.dates,
        // monthExists: action.payload.monthExists,
      };
    case UPDATE_ISDEMOSSR:
      return {
        ...state,
        isDemoSSR: false,
      };
    case REFRESH_DATA:
      return {
        ...state,
        calendarsList: calendarsListFromObj(action.payload.calendarsList),
        dates: action.payload.dates,
        isDatesReturn: true,
      };

    case ON_SETTINGS_LOAD:
      return {
        //@ts-ignore
        ...state,
        isConnect: action.payload.isConnect,
        userName: action.payload.userName,
        calendarsList: calendarsListFromObj(action.payload.calendarsList),
        googleSettings: action.payload.googleSettings,
      };
    case SET_COMP_ID:
      return {
        //@ts-ignore

        ...state,
        compId: action.payload,
      };
    case SET_IS_ALL_CALENDARS_UNCHECKED:
      return {
        //@ts-ignore

        ...state,
        isAllCalendarsUnchecked: action.payload,
      };
    case CONNECT_ERROR:
      return {
        //@ts-ignore

        ...state,
        connectEtsyError: action.payload.err,
        statusCode: action.payload.statusCode,
      };
    case HANDLE_CONNECT_CLICKED:
      return {
        //@ts-ignore

        ...state,
        isSettingsLoader: true,

        connectClicked: action.payload.connectClicked,
      };

    case CONNECT_BTN_CLICKED:
      return {
        //@ts-ignore
        ...state,
        isNewConnect: true,
        isConnect: action.payload.isConnect,
        isSettingsLoader: false,

        userName: action.payload.userName,
        dates: action.payload.dates,
        calendarsList: calendarsListFromObj(action.payload.calendarsList),
        googleSettings: action.payload.googleSettings,
        isSettingsLoaded: true,
        isDatesReturn: true,
        isLoaded: true,
        calendarsExistArr: action.payload.calendarsExistArr,
      };
    case DISCONNECT_BTN_CLICKED:
      return {
        //@ts-ignore
        isDatesReturn: action.payload.isDatesReturn,
        ...state,
        isConnect: false,
        dates: action.payload.dates,
        calendarsList: calendarsListFromObj(action.payload.calendarsList),
        googleSettings: action.payload.googleSettings,
        userName: '',
      };
    case ADD_EVENT_COLOR:
      return {
        ...state,
        dates: action.payload.dates,
      };
    case UPDATE_CALENDAR_LIST:
      return {
        ...state,
        calendarsList: action.payload,
      };
    default:
      return state;
  }
};
